export default "__VITE_ASSET__29255950__"